import {Identity, Restrictions, Source} from './state/types/common.js';
import * as compat from './restrictions/compat.js';

export function parse(restrictions: string | Restrictions): Restrictions {
    if (typeof restrictions === 'string') {
        if (restrictions === 'cluster' || restrictions === 'local') {
            return restrictions;
        }
        return compat.parse(restrictions);
    }
    return restrictions;
}

export function check(parsedRestrictions: Restrictions,
                      own: [Source | undefined, Identity | undefined],
                      ctx: [Source | undefined, Identity | undefined]): boolean {
    const [ownSource, ownContext] = own;
    const [source, context] = ctx;
    switch (parsedRestrictions) {
        case 'local': {
            if (ownSource) {
                if (ownSource.type === 'local') {
                    return source?.type === 'local';
                }
                if (ownSource.type === 'peer') {
                    if (source?.type === 'peer') {
                        return source?.["node"] === ownSource?.["node"];
                    }
                    return false;
                }
            }
            else {
                return source === undefined || source.type === 'local';
            }
            return true;
        }
        case 'cluster': {
            return true;
        }
        default: {
            if (source?.type === 'cluster') {
                return true;
            }
            return !!compat.check(parsedRestrictions, ownContext, context);
        }
    }
}
